/**
 * Created by Robin on 19/12/2022.
 */

import React, {useContext, useEffect, useState} from "react";

import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Skeleton from '@mui/material/Skeleton';

import APIContext from './../context/APIContext.js';

function ShipSelector(props) {
    const API = useContext(APIContext);
    const [ships, setShips] = useState(false);

    useEffect(() => {
        API.getShips().then((shipData) => {
            setShips(shipData);
        });
    }, [API]);

    if (ships === false) {
        return <Skeleton variant="rounded" height={20} width="100%" animation="pulse"/>
    } else {
        let items = [];

        if (props.allowNull === true) {
            items.push(<MenuItem key={null} value={null}><i>(None)</i></MenuItem>);
        }

        for (const ship of ships) {
            items.push(<MenuItem key={ship.id} value={ship.id}>{ship.name}</MenuItem>);
        }

        return (
            <TextField fullWidth select style={{margin: '10px 0px'}} value={props.value || ''} variant="outlined" label={props.label ?? "Ship"} onChange={props.onChange}>
                {items}
            </TextField>
        )
    }
}

export default ShipSelector;